export default __webpack_public_path__ + "static/media/Notification.9e45ca57.svg";